<template>
  <div
    class="hm-check-box-group"
    :class="{
      correct: correct && displayCorrect,
      wrong: selected && !correct && displayCorrect,
    }"
  >
    <div class="checkmark me-2">
      <i
        v-if="selected && correct && displayCorrect"
        class="fas fa-check-circle c-light-green"
      ></i>
      <i
        v-if="selected && !correct && displayCorrect"
        class="fas fa-times-circle c-coral"
      ></i>
      <i
        v-if="selected && !displayCorrect"
        class="fas fa-check-circle c-brand-color"
      ></i>
      <i v-if="!selected" class="fal fa-circle c-medium-gray"></i>
    </div>
    <div class="label c-medium-gray">
      <span :class="{ 'c-charcoal': selected || correct }">
        {{ label }}
      </span>
    </div>
    <div class="correct-tag ms-3" v-if="correct && !selected && displayCorrect">
      <span class="text-uppercase c-light-green smaller">
        {{ $t('QUIZZES.LABEL.CORRECT') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMCheckBoxGroupPreview',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    displayCorrect: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.hm-check-box-group {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  padding: 0.75rem 1rem;
  width: fit-content;
  border-radius: $border-radius;
  color: $charcoal;
  margin-bottom: 6px;

  &.correct {
    background-color: lighten($light-green, 30%);
  }

  &.wrong {
    background-color: lighten($coral, 30%);
  }
}
</style>
